const CommentType = {
  DRAFT: 'draft',
  CHAPTER_TITLE: 'chapterTitle',
  CHAPTER_DESCRIPTION: 'chapterDescription',
  BOOK_SAMPLE: 'bookSample',
  OTHER: 'other',
  BOOK_PDF: 'bookPDF',
};

module.exports = CommentType;
